<template>
  <v-container>
    <v-row justify="center">
      <v-btn
        text
        outlined
        class="ma-2"
        @click="confirmDialog=true">
        リクエスト解除
      </v-btn>
    </v-row>
    <v-dialog
      v-model="confirmDialog"
      persistent
      max-width="600px">
      <v-card>
        <v-card-title>
          <span>
            {{ student.fullName() }}さん
          </span>
        </v-card-title>
        <div
          v-if="teaching">
          <v-card-text>
            <v-icon>warning</v-icon><br>
            <span style="color:#ff0000;">
              {{ student.fullName() }}さんには授業予定があります。リクエスト解除はできません。
            </span><br>
            <span style="color:#ff0000;">
              授業の詳細は「授業一覧」から確認できます。
            </span>
          </v-card-text>
          <v-row justify="end">
            <v-btn
              text
              outlined
              class="ma-5"
              @click="confirmDialog=false">
              はい
            </v-btn>
          </v-row>
        </div>
        <div v-else>
          <v-card-text>
            本当にリクエスト解除しますか？
          </v-card-text>
          <v-row justify="end">
            <v-btn
              text
              rounded
              outlined
              class="ma-5"
              @click="removeStudent()">
              はい
            </v-btn>
            <v-btn
              text
              rounded
              outlined
              class="ma-5"
              @click="confirmDialog=false">
              いいえ
            </v-btn>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <VProgress
      v-model="inProgress"
    />
  </v-container>
</template>

<script>
import { firestore } from "@/repository/client/firestore.js"
import { RelationsBreaker } from '@/service/request/break-off-relations.js'
import { RequestRepository } from '@/repository/RequestRepository.js'
import VProgress from '@/components/organisms/VProgress.vue'

export default {
  name: 'RemoveRequest',
  components: {
    "VProgress": VProgress,
  },
  data() {
    return {
      confirmDialog: false,
      requests: null,
      teacher: this.$store.getters.teacher,
      inProgress: false,
    }
  },
  props: {
    student: Object
  },
  methods: {
    async removeStudent() {
      this.inProgress = true
      this.confirmDialog = false
      const breaker = new RelationsBreaker(firestore, this.teacher)
      this.teacher = await breaker.execute(this.student.id)
      this.$store.commit("loginAsTeacher", this.teacher)
      this.$emit("deleteStudent", this.student)
      this.inProgress = false
    },
  },
  computed: {
    teaching() {
      return this.teacher.lessons.getStudentIds().includes(this.student.id)
    }
  }
}
</script>